import axios from "../network/reuset";
import qs from "qs";

const getUser = {
  getUserList(params) {
    return axios.post(`/api/admin/user/user_list`, qs.stringify(params));
  },
  addUser(params) {
    return axios.post(`/api/admin/user/create_user`, qs.stringify(params));
  },
  getUserInfo(params) {
    return axios.post(`/api/admin/user/user_info`, qs.stringify(params));
  },
  getRiskInfo(params) {
    return axios.post(`/api/admin/user/risk_info`, qs.stringify(params));
  },
  saveUserInfo(params) {
    return axios.post(`/api/admin/user/save_info`, qs.stringify(params));
  },
  getUserLoginList(params) {
    return axios.post(`/api/admin/user/login_list`, qs.stringify(params));
  },
  bannedUser(params) {
    return axios.post(`/api/admin/user/banned_user`, qs.stringify(params));
  },
  getOverviewStats(params) {
    return axios.post(`/api/admin/user/overview_stats`, qs.stringify(params));
  },
  getRiskUserList(params) {
    return axios.post(`/api/admin/user/risk_list`, qs.stringify(params));
  },
  getFilterOptions(params) {
    return axios.post(`/api/admin/user/filter_options`, qs.stringify(params));
  },
  getRiskActionList(params) {
    return axios.post(`/api/admin/user/risk_action_list`, qs.stringify(params));
  },
  postAddUser(params) {
    return this.addUser(params);
  },
  postSaveUserInfo(params) {
    return this.saveUserInfo(params);
  },
  postBannedUser(params) {
    return this.bannedUser(params);
  },
};

export default getUser;
